// extracted by mini-css-extract-plugin
export default {"rootDesktop":"SearchLoadingMessage-module__rootDesktop___YIjpO","rootMobile":"SearchLoadingMessage-module__rootMobile___rUxwF","text":"SearchLoadingMessage-module__text___yaRgU"};